<template>
    <div @click="onSelect"
         @mouseover="hovered = true"
         @mouseleave="hovered = false"
         class="row document-row mx-0 px-3"
         :class="{'selected-doc-row': isSelected}">
        <div class="col-1 pl-0 pr-1">
            <AppStatusColoredRect
                v-tooltip="status.name"
                :color="status.color"
                :with-checkbox="isSelected"
                :with-inner-square="false"/>
        </div>
        <div class="col-2 px-0">
            {{ doc.number || '-' }}
        </div>
        <div class="col-2 px-0">
            {{ dt.name || '-' }}
        </div>
        <div class="col-2 px-0">
            {{ doc.dateInv | moment_format('ll') }}
        </div>
        <div class="col-3 pl-0">
            {{ doc.company && doc.company.name ? doc.company.name : '-' }}
        </div>
        <div class="col-2 align-self-center text-right pr-0">
            <span v-if="doc.total" class="row-total">
                {{ formattedTotal }}
            </span>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getDefaultFormattedMoney} from '@/utils/currency'
import AppStatusColoredRect from '@/components/shared/AppStatusColoredRect'

export default {
    name: 'DocumentRow',
    components: {AppStatusColoredRect},
    props: {
        doc: {
            type: Object,
            required: true
        },
        isSelected: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            hovered: false
        }
    },
    computed: {
        ...mapGetters('documents', [
            'documentTypeSelected',
            'getDocumentStatusModel',
            'getDocumentTypeModel'
        ]),

        status() {
            return this.getDocumentStatusModel(this.doc)
        },

        dt() {
            return this.getDocumentTypeModel(this.item)
        },

        formattedTotal() {
            return getDefaultFormattedMoney(this.doc.total, _.get(this.doc, 'currency.symbol', ''))
        }
    },
    methods: {
        onSelect() {
            this.$emit('select', this.doc)
        }
    }
}
</script>

<style scoped lang="scss">
button {
    width: 160px;
}

.document-row {
    border-bottom: 1px solid $color-grey-light;
    line-height: 16px;
    padding: 12px 0;
    text-align: left;
    align-items: center;

    &:hover {
        cursor: pointer;
    }
}

.status-circle {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    color: $color-black-soft;
    display: inline-block;
}

.row-total {
    font-weight: 500;
}

.selected-doc-row {
    background-color: $color-purple-soft;
}
</style>
